import React from 'react';
import css from './TopbarSearchForm.module.css';
import myIcon from '../assets/search_icon.png';

const IconSearchDesktop = () => (
  <img src={myIcon} style={{width: '18px'}} alt="Search Icon" className={css.iconImage} />
);

export default IconSearchDesktop;